import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { NavUser } from './NavUser';
import { NavUserMenu } from './NavUserMenu';
import { GdacsHeader } from './GdacsHeader';
import { GdacsFooter } from './GdacsFooter';
import { useViewPort } from '../Hooks/useViewPort';
const breakpoint = 620;

export default function Layout(props) {
    const { width } = useViewPort();
    return (
        <div id="wrapper">
            <GdacsHeader />
            <Container className="container_page">
                <NavUser />
                <NavUserMenu />
                {props.children}
                <GdacsFooter />
            </Container>
      </div>
    );
}
